/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactIn
 */
export interface ContactIn {
    /**
     * 
     * @type {string}
     * @memberof ContactIn
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactIn
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactIn
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ContactIn
     */
    contactTypeId: number;
    /**
     * 
     * @type {number}
     * @memberof ContactIn
     */
    parentId?: number;
}

export function ContactInFromJSON(json: any): ContactIn {
    return ContactInFromJSONTyped(json, false);
}

export function ContactInFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactIn {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'name': json['name'],
        'contactTypeId': json['contactTypeId'],
        'parentId': !exists(json, 'parentId') ? undefined : json['parentId'],
    };
}

export function ContactInToJSON(value?: ContactIn | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phone': value.phone,
        'email': value.email,
        'name': value.name,
        'contactTypeId': value.contactTypeId,
        'parentId': value.parentId,
    };
}


